import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { BottomSheet, Modal } from '@drone-js/core';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { selectScreenSize } from 'store/slice/screen';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import {
    ActivitiesOverviewModalSeenEventActivitiesFieldsV1,
    ActivitiesOverviewSheetSeenEventActivitiesFieldsV1,
} from '@agoda/analytics-messages-definition-activities/events.split';
import {
    ActivitiesOverviewModalSeenEventActivitiesManifestV1,
    ActivitiesOverviewSheetSeenEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';

interface Props {
    activityDescription: ReactNode;
    visible: boolean;
    onClose: () => void;
}

const OverviewDescription: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const screenSize = useSelector(selectScreenSize);

    React.useEffect(() => {
        if (props.visible) {
            screenSize.desktop
                ? trackElementEvent<ActivitiesOverviewModalSeenEventActivitiesFieldsV1>(ActivitiesOverviewModalSeenEventActivitiesManifestV1.ids, {})
                : trackElementEvent<ActivitiesOverviewSheetSeenEventActivitiesFieldsV1>(ActivitiesOverviewSheetSeenEventActivitiesManifestV1.ids, {});
        }
    }, [props.visible, screenSize.desktop]);

    return (
        <>
            {screenSize.desktop ? (
                <Modal
                    data-element-name="activities-overview-modal"
                    data-testid="activities-overview-modal"
                    visible={props.visible}
                    onClose={props.onClose}
                    size="l"
                    zIndex={1060}
                    title={cms[337252]}
                >
                    {props.activityDescription}
                </Modal>
            ) : (
                <BottomSheet
                    data-element-name="activities-overview-sheet"
                    data-testid="activities-overview-sheet"
                    title={cms[337252]}
                    visible={props.visible}
                    onChange={props.onClose}
                    closeButton={{
                        'aria-label': cms[126815],
                    }}
                    height="content-fit"
                    p="12"
                >
                    {props.activityDescription}
                </BottomSheet>
            )}
        </>
    );
};
OverviewDescription.displayName = 'OverviewDescription';

export default OverviewDescription;
